/**
 * Step Gamer shared motion helpers:
 * - scroll reveal
 * - countdown timer
 * - marquee pause on reduced motion
 */
(function () {
  'use strict';

  function initReveal() {
    var nodes = document.querySelectorAll('.step-gamer-reveal:not([data-sg-reveal-ready])');
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
        el.setAttribute('data-sg-reveal-ready', '');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    nodes.forEach(function (el) {
      el.setAttribute('data-sg-reveal-ready', '');
      observer.observe(el);
    });
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdowns() {
    var timers = document.querySelectorAll('[data-sg-countdown]:not([data-sg-countdown-ready])');
    timers.forEach(function (el) {
      el.setAttribute('data-sg-countdown-ready', '');
      var end = el.getAttribute('data-sg-countdown');
      if (!end) return;
      var endDate = new Date(end);
      if (isNaN(endDate.getTime())) {
        el.hidden = true;
        return;
      }

      function tick() {
        var now = new Date();
        var diff = endDate.getTime() - now.getTime();
        if (diff <= 0) {
          el.hidden = true;
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        var dLabel = el.getAttribute('data-sg-label-d') || 'd';
        var hLabel = el.getAttribute('data-sg-label-h') || 'h';
        var mLabel = el.getAttribute('data-sg-label-m') || 'm';
        var sLabel = el.getAttribute('data-sg-label-s') || 's';
        el.textContent =
          (days > 0 ? days + dLabel + ' ' : '') +
          pad(hours) +
          hLabel +
          ' ' +
          pad(mins) +
          mLabel +
          ' ' +
          pad(secs) +
          sLabel;
        requestAnimationFrame(function () {
          setTimeout(tick, 1000);
        });
      }
      tick();
    });
  }

  function boot() {
    initReveal();
    initCountdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
